var React = require('react');

function AudioDownloadInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"download"},[React.createElement("path",{"id":"Vector","d":"M16 10V12.6667C16 13.0203 15.8595 13.3594 15.6095 13.6095C15.3594 13.8595 15.0203 14 14.6667 14H5.33333C4.97971 14 4.64057 13.8595 4.39052 13.6095C4.14048 13.3594 4 13.0203 4 12.6667V10","stroke":"#111F5B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M7 6L10 10L13 6","stroke":"#111F5B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"id":"Vector_3","d":"M10 10V2","stroke":"#111F5B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]));
}

AudioDownloadInline.defaultProps = {"width":"21","height":"18","viewBox":"0 0 21 18","fill":"none"};

module.exports = AudioDownloadInline;

AudioDownloadInline.default = AudioDownloadInline;
